import { useEffect, useState } from 'preact/hooks';
import { detectOS, tryDeepLink, getStoreUrl, APP_STORE_URL, PLAY_STORE_URL } from '../utils/appStore';
import styles from '../styles/AppRedirect.module.css';
import logoImage from '../assets/images/logo.png';
import textLogoImage from '../assets/images/olym_text_logo.png';

export default function CenterRedirect({ centerId }) {
  const [status, setStatus] = useState('loading');
  const os = detectOS();
  const storeUrl = getStoreUrl(os);

  useEffect(() => {
    if (!centerId) {
      setStatus('error');
      return;
    }

    // 딥링크 경로: center/{centerId}
    const deepLinkPath = `center/${centerId}`;
    const tried = tryDeepLink(deepLinkPath, os);

    if (tried) {
      // 모바일: 딥링크 시도 중
      setStatus('redirecting');

      // 일정 시간 후에도 페이지가 보이면 앱이 열리지 않은 것으로 판단하여 버튼 표시
      const timer = setTimeout(() => {
        if (!document.hidden) {
          setStatus('showStoreButton');
        }
      }, 1500);

      return () => clearTimeout(timer);
    } else {
      // 데스크톱: 스토어 버튼 표시
      setStatus('desktop');
    }
  }, [centerId, os]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <img src={logoImage} alt="olym" className={styles.logoImage} />
          <img src={textLogoImage} alt="olym" className={styles.textLogoImage} />
        </div>

        {status === 'loading' && (
          <>
            <div className={styles.spinner} />
            <p className={styles.message}>앱으로 이동 중...</p>
            <p className={styles.subMessage}>잠시만 기다려주세요</p>
          </>
        )}

        {status === 'redirecting' && (
          <>
            <div className={styles.spinner} />
            <p className={styles.message}>센터 상세로 이동 중...</p>
            <p className={styles.subMessage}>잠시만 기다려주세요</p>
          </>
        )}

        {status === 'showStoreButton' && (
          <>
            <p className={styles.message}>앱이 설치되어 있나요?</p>
            <p className={styles.subMessage}>앱이 열리지 않았다면 아래 버튼을 눌러 설치해주세요</p>
            <div className={styles.storeButtons}>
              <a href={storeUrl} className={styles.storeButton}>
                {os === 'ios' ? 'App Store에서 다운로드' : 'Google Play에서 다운로드'}
              </a>
            </div>
          </>
        )}

        {status === 'desktop' && (
          <>
            <p className={styles.message}>모바일에서 접속해주세요</p>
            <p className={styles.subMessage}>olym 앱은 모바일에서만 이용 가능합니다</p>
            <div className={styles.storeButtons}>
              <a href={APP_STORE_URL} className={styles.storeButton} target="_blank" rel="noopener noreferrer">
                App Store
              </a>
              <a href={PLAY_STORE_URL} className={styles.storeButton} target="_blank" rel="noopener noreferrer">
                Google Play
              </a>
            </div>
          </>
        )}

        {status === 'error' && (
          <>
            <p className={styles.message}>잘못된 접근입니다</p>
            <p className={styles.subMessage}>센터 정보를 찾을 수 없습니다</p>
          </>
        )}
      </div>
    </div>
  );
}
